import { useEffect, useRef } from 'react'
import { getSystemScripts } from '@/service/api/setting'
import { ScriptConfig } from '@/types/setting'

export const SystemScripts = () => {
  const injectedRef = useRef<Set<string>>(new Set())

  useEffect(() => {
    const fetchAndInject = async () => {
      try {
        const scripts = await getSystemScripts()
        if (!scripts || !Array.isArray(scripts)) return

        scripts.forEach((script: ScriptConfig) => {
          // 避免重复注入
          if (!script.enabled || injectedRef.current.has(script.id)) return

          try {
            const div = document.createElement('div')
            div.innerHTML = script.code

            const target = script.position === 'head' ? document.head : document.body

            Array.from(div.childNodes).forEach(node => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                const element = node as HTMLElement
                if (element.tagName === 'SCRIPT') {
                  const newScript = document.createElement('script')
                  Array.from(element.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value))
                  newScript.text = element.innerHTML
                  target.appendChild(newScript)
                } else {
                  target.appendChild(element.cloneNode(true))
                }
              }
            })
            
            injectedRef.current.add(script.id)
          } catch (e) {
            console.error('Failed to inject script:', script.name, e)
          }
        })
      } catch (e) {
        console.error('Failed to fetch scripts:', e)
      }
    }

    fetchAndInject()
  }, [])

  return null
}
